import IconButton from '@mui/material/IconButton';
import Stack from '@mui/material/Stack';
import DeleteIcon from '@mui/icons-material/Delete';
import AlarmIcon from '@mui/icons-material/Alarm';
import AddShoppingCartIcon from '@mui/icons-material/AddShoppingCart';

/* __next_internal_client_entry_do_not_use__ default auto */ import { createDemoClient } from '@mui/internal-core-docs/utils/createDemoClient';
const ClientProvider = createDemoClient(import.meta.url, { precompute: { externals: { "@mui/material/IconButton": IconButton, "@mui/material/Stack": Stack, "@mui/icons-material/Delete": DeleteIcon, "@mui/icons-material/Alarm": AlarmIcon, "@mui/icons-material/AddShoppingCart": AddShoppingCartIcon } } });
export default ClientProvider;
